document.addEventListener('DOMContentLoaded', function () {
  var dropdowns = document.querySelectorAll('.nav-item.dropdown');

  dropdowns.forEach(function (dropdown) {
    var toggle = dropdown.querySelector('.nav-link.dropdown-toggle');
    var menu = dropdown.querySelector('.dropdown-menu');

    // Show on hover
    dropdown.addEventListener('mouseenter', function () {
      var bsDropdown = new bootstrap.Dropdown(toggle);
      bsDropdown.show();
    });

    // Hide when leaving
    dropdown.addEventListener('mouseleave', function () {
      var bsDropdown = bootstrap.Dropdown.getInstance(toggle);
      if (bsDropdown) bsDropdown.hide();
    });

    // Show when focused via keyboard
    toggle.addEventListener('focus', function () {
      var bsDropdown = new bootstrap.Dropdown(toggle);
      bsDropdown.show();
    });

    // Hide when focus leaves dropdown
    menu.addEventListener('focusout', function (e) {
      if (!dropdown.contains(e.relatedTarget)) {
        var bsDropdown = bootstrap.Dropdown.getInstance(toggle);
        if (bsDropdown) bsDropdown.hide();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var dropdownLinks = document.querySelectorAll('.nav-item.dropdown > .nav-link');

  dropdownLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href !== '#' && href !== '') {
        window.location.href = href; // Follow the link normally
      }
    });
  });
});